/*
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 
 */
export const genders=[{
  text:'男',
  value:1
},{
  text:'女',
  value:2
}]
export const phyStatusList=[{
  text:'普通成人',
  value:1
},{
  text:'未成年人',
  value:2
},{
  text:'孕期',
  value:3
},{
  text:'哺乳期',
  value:4
},{
  text:"疾病康复期",
  value:5
}]
export const occTypeList=[{
  text:'静态工作',
  value:1
},{
  text:'中度活动',
  value:2
},{
  text:'重度体力',
  value:3
}]
// 民族列表
export const ethnicityList=["汉族","蒙古族","回族","藏族","维吾尔族","苗族","彝族","壮族","布依族","朝鲜族","满族","侗族","瑶族","白族","土家族","哈尼族","哈萨克族","傣族","黎族","傈僳族","佤族","畲族","高山族","拉祜族","水族","东乡族","纳西族","景颇族","柯尔克孜族","土族","达斡尔族","仫佬族","羌族","布朗族","撒拉族","毛南族","仡佬族","锡伯族","阿昌族","普米族","塔吉克族","怒族","乌孜别克族","俄罗斯族","鄂温克族","德昂族","保安族","裕固族","京族","塔塔尔族","独龙族","鄂伦春族","赫哲族","门巴族","珞巴族","基诺族"]

export const skeletal_muscleList=[{
  text:'低标准',
  value:'低标准'
},{
  text:'标准',
  value:'标准'
},{
  text:'超标准',
  value:'超标准'
}]
